import { render } from "./EnvironmentView.vue?vue&type=template&id=4bf691bc&scoped=true"
import script from "./EnvironmentView.vue?vue&type=script&lang=js"
export * from "./EnvironmentView.vue?vue&type=script&lang=js"

import "./EnvironmentView.vue?vue&type=style&index=0&id=4bf691bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bf691bc"]])

export default __exports__